import { SHOW_LOADER, HIDE_LOADER } from './AlertActionTypes';

export const showLoading = () => async (dispatch) => {
	dispatch({ type: SHOW_LOADER });
};
export const hideLoading = () => async (dispatch) => {
	dispatch({ type: HIDE_LOADER });
};
